import type { Role } from '@cockpit/shared';

export const ROLE_LABEL: Record<Role, string> = {
  admin: 'Administrateur',
  direction: 'Direction',
  da: 'Directeur d’agence',
};
